import Vue from "vue";
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router';
import store from './store';
import routes from "./router";
import { MdProgress } from 'vue-material/dist/components';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import { ACTIONS, MUTATIONS } from './store/wizard/types';
import { setParamsToStore } from './utils';
import PortalVue from "portal-vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueI18n)

// Translations
import de from './lang/de.json';
import en from './lang/en.json';
import fr from './lang/fr.json';

const messages = {
    de: de,
    en: en,
    fr: fr
};

const i18n = new VueI18n({
    legacy: false,
    locale: window.appLocale,
    messages, 
    fallbackLocale: 'en', 
});

Vue.use(PortalVue);
Vue.use(MdProgress);
Vue.use(VueToast, {
    position: 'bottom',
    pauseOnHover: false,
});

Vue.use(VueRouter);
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 })
            }, 500)
        })
    },
    routes
});


window.store = store;
window.router = router;
router.beforeEach(async (to, from, next) => {
    store.commit(MUTATIONS.SET_UI, { showSteps: !['email-sent', 'contact', 'resume'].includes(to.name) });
    i18n.locale = to.params.locale;
    if (! store.state.catalog) {
        await store.dispatch(ACTIONS.RETRIEVE_CATALOG);
    }
    try {
        setParamsToStore(to);
        next();
    } catch {
        window.location = '/404';
    }
});

Vue.component("base-wizard", require("./components/wizard/BaseWizard.vue").default);
Vue.component("card-rectangle", require("./components/wizard/cards/CardRectangle.vue").default);
Vue.component("card-square", require("./components/wizard/cards/CardSquare.vue").default);
Vue.component("card-icon-rectangle", require("./components/wizard/cards/CardIconRectangle.vue").default);

if (document.querySelector('#wizard')) {
    new Vue({
        el: "#wizard",
        store,
        router,
        i18n
    });
}
